import { i18n } from "../src/plugins/i18n";

const content = {
  page_title: "Analytics",
  devices_table: [
    {
      text: "",
      value: "mdi-map-marker-plus",
      sortable: false,
      of_type: "action",
      condition: "CurrentLat",
      check: true,
    },
    {
      align: "start",
      text: i18n.t("views.Analytics.tables.devices.columns.id"),
      value: "DeviceID",
      sortable: true,
      of_type: "link",
      identifier: "DeviceID",
      url: "/asset/",
    },
    {
      text: i18n.t("views.Analytics.tables.devices.columns.type"),
      value: "DeviceType",
      of_type: "text",
    },
    {
      text: i18n.t("views.Analytics.tables.devices.columns.t_name"),
      value: "DeviceName",
      of_type: "text",
    },

    {
      text: i18n.t("views.Analytics.tables.devices.columns.t_size"),
      value: "PowerRating",
      of_type: "text",
    },
    {
      text: i18n.t("views.Analytics.tables.devices.columns.capacity.text"),
      value: "Utilisation",
      of_type: "text",
      suffix: "%",
      tooltip: i18n.t(
        "views.Analytics.tables.devices.columns.capacity.tooltip"
      ),
    },
    {
      text: i18n.t("views.Analytics.tables.devices.columns.power.text"),
      value: "TotalPower",
      of_type: "text",
      suffix: " kVA",
      tooltip: i18n.t("views.Analytics.tables.devices.columns.power.tooltip"),
    },
    {
      text: i18n.t("views.Analytics.tables.devices.columns.l_message"),
      value: "LastMessageTime",
      of_type: "date",
    },
  ],
  maps_config: {
    id: "DeviceID",
    infoText: "DeviceName",
    label: "DeviceID",
    lat: "CurrentLat",
    lng: "CurrentLng",
    url: "asset",
    type: "HasIssue",
    datatype: "powerdata",
  },
  overview_select: [
    {
      label: i18n.t("common.times.time.last24Hours"),
      type: "days",
      value: "1",
    },
    {
      label: i18n.t("common.times.time.lastWeek"),
      type: "days",
      value: "7",
    },
    {
      label: i18n.t("common.times.time.last4Weeks"),
      type: "days",
      value: "28",
    },
    {
      label: i18n.t("common.times.time.last8Weeks"),
      type: "days",
      value: "56",
    },
  ],
  diversity_chart_data: {
    id: "diversity_chart",
    type: "line",
    label: "RMS Voltage (V)",
    xAxis: "Hours",
    yAxis: "Normalized Power",
    colors: ["#52a0d2"],
  },
  diversity_chart_data1: {
    id: "diversity_chart1",
    type: "line",
    label: "RMS Voltage (V)",
    xAxis: "Hours",
    yAxis: "Normalized Power",
    colors: ["#52a0d2"],
  },
};

export { content };
